import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        rooms: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'planning.Manage rooms' | translate }}</h1>
            <a ng-if="vm.canManagePlanning" class="btn add" ui-sref="authorized.courses.rooms.add()">{{ 'planning.Add room' | translate }}</a>
        </div>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                <tr>
                    <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'planning.Room' | translate }}</th>
                    <th ng-class="vm.list.getSortClass('capacity')"><a ng-click="vm.list.sortBy('capacity')">{{ 'planning.Capacity' | translate }}</th>
                    <th class="actions">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr ng-repeat="item in vm.list.items">
                    <td>{{ item.name }}</td>
                    <td>{{ item.capacity}}</td>
                    <td class="actions">
                        <a ng-if="vm.canManagePlanning" class="btn edit"
                        ui-sref="authorized.courses.rooms.detail({ id: item.id})">{{ 'general.Edit' | translate }}</a>
                    </td>
                </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
`
})
export default class {
    constructor (DATATABLES, ListFactory, RoomResource, PrivilegeService) {
        this.DATATABLES = DATATABLES;
        this.canManagePlanning = PrivilegeService.canManagePlanning();
        this.list = ListFactory.createWithPagination(RoomResource.query.bind(RoomResource));
        this.list.fetch();
    }
}




// WEBPACK FOOTER //
// ./src/app/components/courses/rooms/list/index.js